<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="选择分类">
        <a-select
          showSearch
          placeholder="选择分类"
          optionFilterProp="children"
          style="width: 200px"
          :filterOption="filterOption"
          v-model="form.cate_id"
        >
          <a-select-option :value="0">请选择</a-select-option>
          <a-select-option
            v-for="(item, key) in cateList"
            :key="key"
            :value="item.id"
            >{{ item.cate_name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="文章标题">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.title"
        ></a-input>
      </a-form-item>

      <a-form-item label="文章作者">
        <a-input
          type="text"
          style="width: 200px"
          v-model="form.author"
        ></a-input>
      </a-form-item>

      <a-form-item label="文章简介">
        <a-textarea
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>

      <a-form-item label="文章内容">
        <Editor
          v-if="data_got"
          @callback="updateEditor"
          :data="form.content"
          folder="article"
        />
      </a-form-item>
      <a-form-item label="外部链接">
        <a-input style="width: 600px" type="text" v-model="form.link"></a-input>
      </a-form-item>

      <a-form-item label="附件">
        <UploadFile
          v-if="data_got"
          @callback="uploaded"
          :mult="true"
          folder="article"
          :oldFiles="form.files"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">提交保存</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.files {
  margin-top: 20px;
  .file {
    height: 32px;
    line-height: 24px;
  }
}
</style>

<script>
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";

export default {
  components: { UploadFile, Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      data_got: false,
      type: 0,
      form: {
        type: 0,
        cate_id: 0,
        title: "",
        author: "",
        desc: "",
        content: "",
        link: "",
        files: "",
      },
    };
  },
  async created() {
    this.type = this.$route.query.type;
    // 获取所有的资料分类
    const r = await this.$axios.get("/article/getCateList?type=" + this.type);
    if (r.status == 1) this.cateList = r.list;
  },
  async mounted() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/article/getArticleDetail?id=" + id);

    if ((r.status = 1)) {
      this.form = r.article;
      this.data_got = true;
    } else {
      this.$message.error(r.msg);
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async sub() {
      const that = this;
      if (!that.form.cate_id) {
        that.$message.error("请选择分类");
        return;
      }
      if (!that.form.title) {
        that.$message.error("请填写标题");
        return;
      }
      const r = await that.$axios.post("/article/updateArticle", this.form);

      if (r.status == 1) {
        that.$router.push("/article/list?type=" + that.type);
      }
    },

    uploaded(files) {
      console.log(files);
      this.form.files = files;
    },
    updateEditor(data) {
      this.form.content = data;
    },
  },
};
</script>